// Mahjong's and Mahjong Connect's help (owner 2026-10-24): the hint shows one pair of free matching tiles for a moment (board.css
// data-hint); with no move left the "No moves" window opens by itself, with Shuffle (free), Undo and New game
// (windows/SimpleWindows.tsx NoMovesWindow). The card games have no hint; their "No more moves" notice is ui/lostGame.ts.
import type { GameController } from '../engine/controller';
import { RULES } from '../engine/rules';
import { uiStore } from '../store/uiStore';

/** How long the hinted pair stays marked. */
const HINT_MS = 2200;
let hintTimer = 0;
/** The "No moves" window waits for the last pair's flight. */
const STUCK_DELAY_MS = 600;

function clearHint() {
  window.clearTimeout(hintTimer);
  for (const el of document.querySelectorAll('.card[data-hint]')) el.removeAttribute('data-hint');
}

/** The hint: one free matching pair marked (the first found, so the same position always gets the same answer) at
 *  HINT_PENALTY points (engine/scoring.ts), or the "No moves" window when there is none (free). */
export function showHint(ctrl: GameController): void {
  const s = ctrl.getState();
  if (!RULES[s.game].tiles || s.won || s.status !== 'idle') return;
  clearHint();
  const pair = ctrl.hint();
  if (!pair) {
    uiStore().openWindow('no_moves', {});
    return;
  }
  for (const i of pair) document.querySelector(`.card[data-pile="tableau-${i}"]`)?.setAttribute('data-hint', '');
  hintTimer = window.setTimeout(clearHint, HINT_MS);
}

/** Opens the "No moves" window when a Mahjong position has no move left, and closes it when one comes back (an undo
 *  from the top bar, the shuffle). Checked once per position and status. */
export function watchNoMoves(ctrl: GameController): void {
  let seen: unknown = null;
  let seenStatus = '';
  ctrl.subscribe((s) => {
    // the end of a deal changes only the status (a deal with no move from the start)
    if (s.piles === seen && s.status === seenStatus) return;
    if (s.piles !== seen) clearHint();
    seen = s.piles;
    seenStatus = s.status;
    const ui = uiStore();
    const open = ui.isOpen('no_moves');
    const stuck = RULES[s.game].tiles === true && s.deals > 0 && s.status === 'idle' && !s.won && !RULES[s.game].pairsLeft?.(s).length;
    // the card games' "No more moves" window (ui/lostGame.ts) is not this one's to close
    if (!stuck && open && RULES[s.game].tiles) ui.closeWindow('no_moves');
    // opened once the last pair has landed on the discard pile
    if (stuck && !open) {
      const piles = s.piles;
      window.setTimeout(() => {
        const now = ctrl.getState();
        if (now.piles === piles && !uiStore().isOpen('no_moves')) uiStore().openWindow('no_moves', {});
      }, STUCK_DELAY_MS);
    }
  });
}
